// Firebase Storage imports
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/config";

// Upload a single file
export const uploadFile = async (
  file: File,
  userId: string
): Promise<string> => {

  // Create storage path
  const fileRef = ref(
    storage,
    `quote-documents/${userId}/${Date.now()}-${file.name}`
  );

  // Upload file
  await uploadBytes(fileRef, file);

  // Return download URL
  return await getDownloadURL(fileRef);
};